import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeeSalaryDetails: [],
    employeeSalaryDetailsCount: 0,
    employeeSalaryDetail: {},
    employeeSalaryDetailSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeeSalaryDetails(state) {
      return state.employeeSalaryDetails
    },
    getEmployeeSalaryDetailsCount(state) {
      return state.employeeSalaryDetailsCount
    },
    getEmployeeSalaryDetail(state) {
      return state.employeeSalaryDetail
    },
    getEmployeeSalaryDetailSaveStatus(state) {
      return state.employeeSalaryDetailSave
    },
    getEmployeeSalaryDetailDeleteStatus(state) {
      return state.employeeSalaryDetailDelete
    },
  },
  mutations: {
    EMPLOYEE_SALARY_DETAILS_LIST(state, data) {
      state.employeeSalaryDetails = data
    },
    EMPLOYEE_SALARY_DETAIL_VIEW(state, data) {
      state.employeeSalaryDetailsCount = data
    },
    EMPLOYEE_SALARY_DETAILS_COUNT(state, data) {
      state.employeeSalaryDetailsCount = data
    },
    EMPLOYEE_SALARY_DETAIL_SAVE(state, data) {
      state.employeeSalaryDetailSave = data
    },
  },
  actions: {
    employeeSalaryDetailsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_salary_details', data)
        .then(response => {
          commit('EMPLOYEE_SALARY_DETAILS_LIST', response.data.data)
          commit('EMPLOYEE_SALARY_DETAILS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeeSalaryDetailView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_salary_details.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_salary_details', data)
        .then(response => {
          commit('EMPLOYEE_SALARY_DETAIL_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeeSalaryDetailSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_salary_details/saveData', data)
        .then(response => {
          commit('EMPLOYEE_SALARY_DETAIL_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
